import { useSyncExternalStore } from 'react';

/**
 * True under 640px, the width where the People, Needs and Growth pages
 * trade their tables for cards and the top nav for a bottom tab bar. One
 * breakpoint, shared with console.module.css, so the markup and the styles
 * agree on where the phone starts. Nothing at 640px and above changes.
 */
export const PHONE_QUERY = '(max-width: 639.98px)';

const query = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(PHONE_QUERY) : null);

const subscribe = (onChange: () => void) => {
  const mq = query();
  if (!mq) return () => {};
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }
  mq.addListener(onChange);
  return () => mq.removeListener(onChange);
};

const read = () => query()?.matches === true;

export const usePhone = (): boolean => useSyncExternalStore(subscribe, read, () => false);
